import { Component, computed, effect, Input, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { LocationListModel } from '../../models/location-list.model';
import { MediaModel } from '../../models/media.model';
import { PoiListModel } from '../../models/poi-list.model';
import { PropertyTypeListModel } from '../../models/property-type-list.model';
import { SettingsModel } from '../../models/setting.model';
import { StaticPageModel } from '../../models/static-page.model';
import { AppService } from '../../services/app.service';
import { MetaService } from '../../services/meta.service';
import { SettingsService } from '../../services/settings.service';
import { SearchboxComponent } from '../../parts/search-box/search-box.component';
import { InnerHtmlComponent } from '../../parts/inner-html/inner-html.component';
import { ApiImagePipe } from '../../pipes/image.pipe';
import { filter, Subscription } from 'rxjs';
import { RoutingService } from '../../services/routing.service';
import { RouteModel } from '../../models/route.model';
import { PropertyListPropertyComponent } from '../../parts/property-list-property/property-list-property.component';

@Component({
  selector: 'app-static-page',
  templateUrl: './static-page.component.html',
  styleUrls: ['./static-page.component.scss'],
  imports: [
    RouterModule,
    SearchboxComponent,
    InnerHtmlComponent,
    ApiImagePipe,
    PropertyListPropertyComponent,
  ],
  standalone: true,
})
export class StaticPageComponent implements OnInit {
  data: StaticPageModel = new StaticPageModel();
  settings: SettingsModel = new SettingsModel();

  locationsWithImage?: LocationListModel[];
  locationsWithoutImage?: LocationListModel[];
  poisWithImage?: PoiListModel[];
  poisWithoutImage?: PoiListModel[];
  propertyTypesWithImage?: PropertyTypeListModel[] = [];
  propertyTypesWithoutImage?: PropertyTypeListModel[] = [];

  sub: Subscription = new Subscription();

  constructor(
    private appService: AppService,
    private settingsService: SettingsService,
    private router: Router,
    private metaService: MetaService,
    private routingService: RoutingService,
  ) {
    effect(() => {
      if (this.routingService.route().Type == 3) {
        this.getData();
      }
    });
  }

  ngOnInit(): void {
    this.settings = this.settingsService.settings();
  }

  getData() {
    if (this.router.url !== '/') {
      this.appService
        .getData(`staticpage?url=${this.routingService.route().Url}`)
        .then((x) => {
          this.data = JSON.parse(x);
          this.setLocationAndPois();
          this.setMeta();
        });
    }
  }

  setLocationAndPois() {
    if (this.data && this.data.Locations && this.data.Locations.length > 0) {
      this.locationsWithImage = this.data.Locations.filter((x) => x.Media);
      this.locationsWithoutImage = this.data.Locations.filter((x) => !x.Media);
    }

    if (this.data && this.data.Pois && this.data.Pois.length > 0) {
      this.poisWithImage = this.data.Pois.filter((x) => x.Media);
      this.poisWithoutImage = this.data.Pois.filter((x) => !x.Media);
    }

    if (
      this.data &&
      this.data.PropertyTypes &&
      this.data.PropertyTypes.length > 0
    ) {
      this.propertyTypesWithImage = this.data.PropertyTypes.filter(
        (x) => x.Media,
      );
      this.propertyTypesWithoutImage = this.data.PropertyTypes.filter(
        (x) => !x.Media,
      );
    }
  }

  setMeta() {
    if (this.data) {
      this.metaService.setMeta(
        this.data.Title ?? '',
        this.data.MetaDescription ?? '',
        this.data.Media ?? new MediaModel(),
        this.router.url,
      );

      if (this.router.url.includes('?')) {
        this.metaService.setCanonical(
          this.settings.ClientId,
          this.router.url.split('?')[0],
        );
      }
    }
  }
}
